import { api } from '@/services/api/main/axios';

export interface ReferralTableQuery {
  offset: number;
  limit: number;
  orderDir?: string;
  orderBy?: string;
}

export interface ReferralReferredPayload {
  items?: unknown[];
  count?: number;
  last30DaysCommission?: number;
  totalCommission?: number;
}

export interface ReferralBalancePayload {
  items?: unknown[];
  count?: number;
}

export const getReferredUsersApiRequest = async (
  params: ReferralTableQuery,
): Promise<ReferralReferredPayload> => {
  const res = await api.get<{ payload: ReferralReferredPayload }>('user/referrals/referred-users', {
    params,
  });
  return res.data.payload;
};

export const getReferralBalanceHistoryApiRequest = async (
  params: ReferralTableQuery,
): Promise<ReferralBalancePayload> => {
  const res = await api.get<{ payload: ReferralBalancePayload }>('user/referrals/balance-history', {
    params,
  });
  return res.data.payload;
};
